package com.mps.asc_app.config

object DebugRegistrationConfig {
    val enabled: Boolean
        get() = isDebugBuild

    // Bitte fuer euer Projekt auf eine valide Place-ID setzen, damit die Registrierung erfolgreich ist.
    const val defaultPlaceId: String = "ChIJt5xQg7CRsUcRg2-FPmTnS0g"
    const val defaultPassword: String = "123456789"
    const val firstName: String = "Marvin"
    const val lastName: String = "TestAccount"
    const val phone: String = "000000000"
    const val emailPrefix: String = "marvinpetersen93"
    const val emailDomain: String = "gmail.com"

    // Test user for "manually checked, no member, no sports" scenario
    const val testUserCheckedNoMemberEmail: String = "marvinpetersen93-testusergeprueftaberkeinmitglied@gmail.com"
    const val testUserCheckedNoMemberPassword: String = "123456789"

    // Test user for "manually checked, has member number, no sports" scenario
    const val testUserHasMemberNumberNoSportEmail: String = "marvinpetersen93-testusermitgliedohnesparte@gmail.com"
    const val testUserHasMemberNumberNoSportPassword: String = "123456789"

    fun isManagedTestUserEmail(email: String): Boolean {
        val normalized = email.trim().lowercase()
        val expectedDomain = emailDomain.lowercase()
        if (!normalized.endsWith("@$expectedDomain")) return false
        val local = normalized.substringBefore("@")
        val expectedPrefix = emailPrefix.lowercase()
        return local == expectedPrefix || local.startsWith("$expectedPrefix+") ||
               normalized == testUserCheckedNoMemberEmail.lowercase() ||
               normalized == testUserHasMemberNumberNoSportEmail.lowercase()
    }
}
